"use client";
import { motion } from "framer-motion";
import consultSectionBgImage from "../../../public/consultSection-bg.jpg";
import Image from "next/image";

const ConsultingSection = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.5, ease: "easeOut" },
    },
  };

  const consultingServices = [
    {
      title: "AI Strategy & Roadmapping",
      description:
        "Comprehensive planning to integrate AI into your business operations effectively.",
    },
    {
      title: "Data Science & Analytics",
      description:
        "Turn your data into actionable insights with advanced analytics solutions.",
    },
    {
      title: "Scalability Solutions",
      description: "Architectures designed to grow with your business needs.",
    },
    {
      title: "Architecture Design",
      description:
        "Robust system designs for optimal performance and reliability.",
    },
  ];

  return (
    <section
      id="consult"
      className="py-24 bg-gray-900 relative overflow-hidden"
    >
      {/* Background elements */}
      <div className="absolute inset-0 opacity-10">
        
         {/* Background Image with overlay */}
        <div className="absolute inset-0 z-0">
          <Image
            src={consultSectionBgImage}
            alt="Background"
            fill
            className="object-cover"
            quality={100}
            priority
          />
        </div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Consulting & Advisory Services */}
        <motion.div variants={containerVariants}>
          <motion.h2
            className="text-4xl md:text-5xl text-center font-bold text-white mb-6"
            variants={itemVariants}
          >
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-sky-500 to-sky-100">Consulting</span> & Advisory Services
          </motion.h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {consultingServices.map((service, index) => (
              <motion.div
                key={index}
                variants={itemVariants}
                whileHover={{ y: -15 }}
                className="bg-gradient-to-br from-sky-400 to-sky-950 backdrop-blur-sm rounded-xl p-8 border border-white/20 hover:border-white/40 transition-all duration-300"
              >
                <h4 className="text-xl font-bold text-white mb-3">
                  {service.title}
                </h4>
                <p className="text-white/80">{service.description}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ConsultingSection;
